import '../styles/PrivacyPolicy.css';

const Support = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Support</h1>
        <p className="last-updated">We're here to help!</p>

        <section>
          <h2>Get Help</h2>
          <p>
            If you need assistance with Hotelia, have questions, or encounter any issues, 
            we're here to help. Please reach out to us using one of the methods below.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:hotelia@thebisbeeinn.com" style={{ color: 'var(--primary-color)' }}>
              hotelia@thebisbeeinn.com
            </a>
          </p>
          <p>
            We typically respond within 24-48 hours. For urgent issues, please include 
            "URGENT" in your subject line.
          </p>
        </section>

        <section>
          <h2>Common Questions</h2>
          
          <h3>How do I create an event?</h3>
          <p>
            Click the "+" button on the home page and select "Create Event". 
            Fill in the event details, set the date and location, and invite your guests.
          </p>

          <h3>How do I join a group?</h3>
          <p>
            You can discover public groups on the home page, or join a group using an invite link 
            shared by a group member.
          </p>

          <h3>How do I RSVP to an event?</h3>
          <p>
            Open the event page and click one of the RSVP buttons: "Going", "Maybe", or "Can't Go". 
            You can update your RSVP at any time.
          </p>

          <h3>How do I invite friends?</h3>
          <p>
            On any event or group page, click "Generate Invite Link" to create a shareable link. 
            You can also invite friends from the Contacts page.
          </p>

          <h3>I'm having trouble logging in</h3>
          <p>
            Make sure you're using the correct email and password. If you've forgotten your password, 
            please contact us at the email above and we'll help you reset it.
          </p>
        </section>

        <section>
          <h2>Report a Bug</h2>
          <p>
            Found a bug or issue? Please email us at{' '}
            <a href="mailto:hotelia@thebisbeeinn.com" style={{ color: 'var(--primary-color)' }}>
              hotelia@thebisbeeinn.com
            </a>{' '}
            with the following information:
          </p>
          <ul>
            <li>Description of the issue</li>
            <li>Steps to reproduce the problem</li>
            <li>What device/browser you're using</li>
            <li>Screenshots (if applicable)</li>
          </ul>
        </section>

        <section>
          <h2>Feature Requests</h2>
          <p>
            Have an idea for a new feature? We'd love to hear it! Send your suggestions to{' '}
            <a href="mailto:hotelia@thebisbeeinn.com" style={{ color: 'var(--primary-color)' }}>
              hotelia@thebisbeeinn.com
            </a>
          </p>
        </section>

        <section>
          <h2>Additional Resources</h2>
          <p>
            <a href="/terms.html" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>
              Terms of Service
            </a>
            {' • '}
            <a href="/privacy.html" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>
              Privacy Policy
            </a>
            {' • '}
            <a href="/sms-consent.html" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>
              SMS Consent
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Support;
